import ChatSharePreview from "@/components/mobile/ChatSharePreview.vue";
import CreateThread from "@/components/mobile/CreateThread.vue";
import MateHome from "@/components/mobile/MateHome.vue";
import MateHomeUser from "@/components/mobile/MateHomeUser.vue";
import MomentChain from "@/components/mobile/MomentChain.vue";
import RequestList from "@/components/mobile/RequestList.vue";
import SocialList from "@/components/mobile/SocialList.vue";
import ThreadCommit from "@/components/mobile/ThreadCommit.vue";
import ThreadDetail from "@/components/mobile/ThreadDetail.vue";
import TreeholeThreadDetail from "@/components/mobile/TreeholeThreadDetail.vue";
import ChatEmpty from "@/components/mobile/chat/ChatEmpty.vue";
import CreateChatGuide from "@/components/mobile/chat/CreateChatGuide.vue";
import MateChatListPage from "@/components/mobile/chat/MateChatListPage.vue";
import GalGameEditorConnect from "@/components/mobile/gal-game/editor/GalGameEditorConnect.vue";
import GalGameEditorDialog from "@/components/mobile/gal-game/editor/GalGameEditorDialog.vue";
import GalGameEditor from "@/components/mobile/gal-game/editor/index.vue";
import GalGameHome from "@/components/mobile/gal-game/home/GalGameHome.vue";
import GalGameDetail from "@/components/mobile/gal-game/home/GalGameHomeDetail.vue";
import CreateStorySceneTask from "@/components/mobile/generation/CreateStorySceneTask.vue";
import CreateVideoTask from "@/components/mobile/generation/CreateVideoTask.vue";
import TraitFeatureExtraction from "@/components/mobile/generation/FeatureExtraction.vue";
import CreateImagePaint from "@/components/mobile/generation/Image/ImagePaint.vue";
import CreateImageWithMode from "@/components/mobile/generation/Image/ImagePaintWithMode.vue";
import CreateTraitTask from "@/components/mobile/generation/Image/ImageTrait.vue";
import CreateMutiTraitImage from "@/components/mobile/generation/Image/MutiTrait.vue";
import TaskList from "@/components/mobile/generation/Task/TaskList.vue";
import PortTraitList from "@/components/mobile/generation/Trait/GenerationPortTraitList.vue";
import PortraitEdit from "@/components/mobile/generation/Trait/GenerationPortraitEdit.vue";
import GenerationTraitList from "@/components/mobile/generation/Trait/GenerationTraitList.vue";
import CreateInpainting from "@/components/mobile/generation/inpaint/CreateInpainting.vue";
import InpaintingEditor from "@/components/mobile/generation/inpaint/InpaintingEditor.vue";
import ContactUs from "@/components/mobile/info/ContactUs.vue";
import ModuleEdit from "@/components/mobile/modules/ModuleEdit.vue";
import ProfileSetting from "@/components/mobile/modules/ProfileSetting.vue";
import ChatSceneEdit from "@/components/mobile/modules/scenario/ChatSceneEdit.vue";
import NotificationList from "@/components/mobile/notification/NotificationList.vue";
import StoryBookEditMoment from "@/components/mobile/story/edit/Moment.vue";
import StoryBookEditRole from "@/components/mobile/story/edit/Role.vue";
import StoryBookEditRoleAdd from "@/components/mobile/story/edit/RoleAdd.vue";
import StoryBookEdit from "@/components/mobile/story/edit/index.vue";
import StoryImgModule from "@/components/mobile/story/img-module/index.vue";
import StoryBookHome from "@/components/mobile/story/story-book/StoryBookHome.vue";
import StoryList from "@/components/mobile/story/story-book/StoryBookList.vue";
import StoryBookReply from "@/components/mobile/story/story-book/StoryBookReply.vue";
import ReadStory from "@/components/mobile/story/story-chapter/ReadStory.vue";
import StoryEditor from "@/components/mobile/story/story-chapter/StoryEditor.vue";
import StoryHome from "@/components/mobile/story/story-chapter/StoryHome.vue";
import StoryInfo from "@/components/mobile/story/story-chapter/StoryInfo.vue";
import StoryRelatingMoment from "@/components/mobile/story/story-chapter/StoryRelatingMoment.vue";
import StoryReply from "@/components/mobile/story/story-chapter/StoryReply.vue";
import StoryShare from "@/components/mobile/story/story-chapter/StoryShare.vue";
import ThreadList from "@/components/mobile/thread/ThreadListPage.vue";
import { useGlobalUser } from "@/stores/globalUser";
import ManagerPrompt from "@/views/Manager/Prompt.vue";
import ChatView from "@/views/Mate/Chat/ChatView.vue";
import { createRouter, createWebHistory } from "vue-router";
// import CreateCustomPainting from "@/components/mobile/generation/custom-painting/CreateCustomPainting.vue";
// import MultipleImageInpaintingEditor from "@/components/mobile/generation/multiple-image-merge/MultipleImageMergeEditor.vue";
import CoinBalanceRecord from "@/components/mobile/coin/CoinBalanceRecord.vue";
import CoinTask from "@/components/mobile/coin/CoinTask.vue";
import PerformanceEditor from "@/components/mobile/gal-game/editor/components/PerformanceEditor.vue";
import AnimationList from "@/components/mobile/generation/animation/AnimationList.vue";
import CreateAnimation from "@/components/mobile/generation/animation/CreateAnimation.vue";
import MultipleImageMergeEditor from "@/components/mobile/generation/multiple-image-merge/MultipleImageMergeEditor.vue";
import RankReplyList from "@/components/mobile/rank/RankReplyList.vue";
import RankSeasonDetail from "@/components/mobile/rank/RankSeasonDetail.vue";
import RankVoteList from "@/components/mobile/rank/RankVoteList.vue";
import RankList from "@/components/mobile/rank/rankList/RankList.vue";
import StoryPerformanceEditor from "@/components/mobile/story/story-chapter/StoryNodePerformanceEditor.vue";
import EditCollection from "@/views/Mate/Collection/EditCollection.vue";
import ListCollection from "@/views/Mate/Collection/ListCollectionPage.vue";
import MainCollection from "@/views/Mate/Collection/MainCollection.vue";
import TransactionPage from "@/views/Transaction/TransactionPage.vue";
import TransactionRecord from "@/views/Transaction/TransactionRecord.vue";

import GoldTicketBalance from "@/components/mobile/coin/GoldTicketBalance.vue";
import GoldTicketBalanceRecord from "@/components/mobile/coin/GoldTicketBalanceRecord.vue";
import SeniorReaderApplication from "@/components/mobile/coin/identity-application/SeniorReaderApplication.vue";
import LoginOrRegister from "@/components/mobile/login/LoginOrRegister.vue";
import UserRegister from "@/components/mobile/login/UserRegister.vue";
import RankRules from "@/components/mobile/rank/RankRules.vue";
import AccountSettings from "@/components/mobile/settings/AccountSettings.vue";
import PaypalPage from "@/views/Transaction/TransactionEditPaypal.vue";
import WithdrawalPage from "@/views/Transaction/TransactionWithdraw.vue";
import WithdrawalRecordPage from "@/views/Transaction/TransactionWithdrawRecord.vue";

import MateChatIntro from "@/components/mobile/chat/MateChatIntro.vue";
import TextImageExploreItem from "@/components/mobile/gallery/TextImageExploreItem.vue";
import GameDemoList from "@/components/mobile/game-demo/GameDemoList.vue";
import PlanetGenerator from "@/components/mobile/modules/worldview.vue/PlanetGenerator.vue";
import About from "@/components/mobile/settings/About.vue";
import AccountInfo from "@/components/mobile/settings/AccountInfo.vue";
import AccountSettingsEmpty from "@/components/mobile/settings/AccountSettingsEmpty.vue";
import AppearanceSetting from "@/components/mobile/settings/AppearanceSetting.vue";
import ContentSetting from "@/components/mobile/settings/ContentSetting.vue";
import LanguageSetting from "@/components/mobile/settings/LanguageSetting.vue";
import PolicyPage from "@/components/mobile/settings/PolicyPage.vue";
import PreferenceSetting from "@/components/mobile/settings/PreferenceSetting.vue";
import FriendList from "@/components/social/FriendList.vue";
import FriendInvitation from "@/components/social/FrirendInvitation.vue";
import DungeonsCreate from "@/views/Dungeons/DungeonsCreate.vue";
import DungeonsDetail from "@/views/Dungeons/DungeonsDetail.vue";
import MateChatView from "@/views/Mate/Chat/MateChatView.vue";
// import DungeonsHome from "@/views/Dungeons/DungeonsHome.vue";
import HomeNew from "@/views/Home/HomeNew.vue";
import HomeInteractiveRelation from "@/views/Home/Interactive/HomeInteractiveRelation.vue";
import HomeInteractiveRelationMy from "@/views/Home/Interactive/HomeInteractiveRelationMy.vue";
import HomeInteractiveRelationOther from "@/views/Home/Interactive/HomeInteractiveRelationOther.vue";

import SpriteModule from "@/components/mobile/modules/mate/SpriteModule.vue";
import DungeonsMine from "@/views/Dungeons/DungeonsMine.vue";
import DungeonsRoom from "@/views/Dungeons/DungeonsRoom.vue";
import DungeonsSpriteEdit from "@/views/Dungeons/DungeonsSpritCreate.vue";
import MobileView from "@/views/MobileViewNew.vue";

import PlanetDetail from "@/components/mobile/PlanetDetail.vue";
import Crystal from "@/views/Crystal/CrystalPage.vue";
import MissionDispatchRank from "@/views/Mate/Mission/MissionDispatchRank.vue";
import MissionEdit from "@/views/Mate/Mission/MissionEdit.vue";
import MissionHome from "@/views/Mate/Mission/MissionHome.vue";
import MissionJourney from "@/views/Mate/Mission/MissionJourney.vue";
import PageTest from "@/views/PageTest.vue";

import InteractionReviewList from "@/components/interaction-review/InteractionReviewList.vue";
import InteractionEventListView from "@/views/Home/Interactive/InteractionEventListView.vue";
import MateWishDemo from "@/components/mobile/mate-wish/MateWishDemo.vue";
import MateWishDetail from "@/components/mobile/mate-wish/MateWishDetail.vue";
import MateWishEdit from "@/components/mobile/mate-wish/MateWishEdit.vue";
import MateWishHome from "@/components/mobile/mate-wish/MateWishHome.vue";
import DrawCanvas from "@/features/draw/DrawCanvas.vue";
import AdoptionCreate from "@/views/Mate/Adoption/AdoptionCreate.vue";
import AdoptionHome from "@/views/Mate/Adoption/AdoptionHome.vue";
import MissionEquipment from "@/views/Mate/Mission/MissionEquipment.vue";
import RoleplayDetail from "@/views/Mate/Roleplay/RoleplayDetail.vue";
import RoleplayExplore from "@/views/Mate/Roleplay/RoleplayExplore.vue";
import RoleplayHome from "@/views/Mate/Roleplay/RoleplayHome.vue";
import RoleplayList from "@/views/Mate/Roleplay/RoleplayListPage.vue";

import ShareXhs from "@/components/mobile/share/ShareXhs.vue";

import MateMailDetail from "@/views/Mate/Mail/MateMailDetail.vue";
import MateMailEdit from "@/views/Mate/Mail/MateMailEdit.vue";
import MateMailListPage from "@/views/Mate/Mail/MateMailListPage.vue";
import MissionJourneyItem from "@/views/Mate/Mission/MissionJourneyItem.vue";

import MateToneModule from "@/components/mobile/modules/mate/MateToneModule.vue";
import PhaserGame from "@/features/dream-home/components/PhaserGame.vue";
import BeautifyView from "@/views/Beautify/BeautifyView.vue";
import GalleryView from "@/views/Mate/Gallery/GalleryView.vue";
import MateTimelineView from "@/views/Mate/Timeline/MateTimelineView.vue";

import MateMemoryEdit from "@/views/Mate/Memory/MateMemoryEdit.vue";
import MateMemoryPage from "@/views/Mate/Memory/MateMemoryPage.vue";

import TreeholeConnect from "@/views/Mate/Treehole/TreeholeConnect.vue";
import TreeholeCreate from "@/views/Mate/Treehole/TreeholeCreate.vue";
import TreeholeIndex from "@/views/Mate/Treehole/TreeholeIndex.vue";
import TreeholeSelfEdit from "@/views/Mate/Treehole/TreeholeSelfsettingEdit.vue";
// import DriftCapsuleHome from "@/views/Mate/DriftCapsule/DriftCapsuleHome.vue";
import DriftCapsuleListPage from "@/views/Mate/DriftCapsule/DriftCapsuleListPage.vue";

// import HomeCreation from "@/views/Home/Creation/HomeCreation.vue";
import HomeParadise from "@/views/Home/Paradise/HomeParadise.vue";
import HomePartner from "@/views/Home/Partner/HomePartner.vue";

import PlaygroundHome from "@/views/Home/Playground/PlaygroundHome.vue";
import MateCreate from "@/views/Mate/Create/MateCreate.vue";
import MateCreateAuto from "@/views/Mate/Create/MateCreateAuto.vue";
import HomeDiscoverV2 from "@/views/Home/Discover/HomeDiscoverV2.vue";

import MemberPage from "@/views/Crystal/MemberPage.vue";
import MemberCenterPage from "@/views/Crystal/MemberCenterPage.vue";

import PowerCubePage from "@/views/User/PowerCubePage.vue";
import FurnishList from "@/features/dream-home/components/furnish/FurnishList.vue";
import UserTask from "@/views/User/UserTask.vue";
import MissionDialogue from "@/components/mobile/chat/mission/MissionDialogue.vue";
import WorldMissionList from "@/views/Mate/Mission/WorldMissionList.vue";
import WorldMissionEdit from "@/views/Mate/Mission/WorldMissionEdit.vue";

declare module "vue-router" {
  interface RouteMeta {
    // 是否显示底部导航栏
    showBottomNav?: boolean;
    // 是否是落地页
    isLandingPage?: boolean;
    // 是否支持不登陆访问
    auth?: boolean;
    // 当前route是否支持Mate切换
    enableSwitchMate?: boolean;
    layout?: {
      // 是否展示右侧边栏
      hideRightSidebar?: boolean;
      showHotCharacter?: boolean;
    };
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "root",
      component: MobileView,
      children: [
        {
          path: "",
          name: "threads",
          redirect: { name: "dreamHome" },

          meta: {
            auth: true,
            showBottomNav: true,
            enableSwitchMate: true,
            layout: {
              showHotCharacter: true,
            },
          },
        },
        {
          path: "discover",
          name: "discover",
          component: HomeDiscoverV2,
          meta: {
            auth: false,
            showBottomNav: true,
          },
        },
        {
          path: "treehole",
          name: "treehole",
          component: TreeholeIndex,
          meta: {
            auth: true,
            showBottomNav: true,
          },
        },
        {
          path: "mate/create",
          name: "mateCreate",
          component: MateCreate,
        },
        {
          path: "mate/create/auto",
          name: "mateCreateAuto",
          component: MateCreateAuto,
          meta: {
            auth: true,
          },
        },
        // {
        //   path: "creation",
        //   name: "creation",
        //   component: HomeCreation,
        //   meta: {
        //     auth: false,
        //   },
        // },

        {
          path: "partner",
          name: "partner",
          component: HomePartner,
          meta: {
            showBottomNav: true,
            enableSwitchMate: true,
            layout: {
              showHotCharacter: true,
            },
          },
        },

        {
          path: "paradise",
          name: "paradise",
          component: HomeParadise,
        },

        {
          path: "power-cube",
          name: "powerCube",
          component: PowerCubePage,
        },

        {
          path: "home",
          name: "home",
          component: HomeNew,
          meta: {
            showBottomNav: false,
          },
        },
        {
          path: "interactive",
          name: "interactive",
          // component: HomeCreation,
          component: HomeNew,
          meta: {
            auth: true,
          },
        },
        {
          path: "interactive/relationship",
          name: "relationshipList",
          component: HomeInteractiveRelation,
          meta: {
            showBottomNav: false,
            auth: true,
          },
        },
        {
          path: "interactive/relationship/other",
          name: "relationshipOther",
          component: HomeInteractiveRelationOther,
          meta: {
            showBottomNav: false,
            auth: true,
          },
        },
        {
          path: "interactive/relationship/my",
          name: "relationshipMy",
          component: HomeInteractiveRelationMy,
        },
        // {
        //   path: "home",
        //   component: HomeGalleryNew,
        //   meta: {
        //     showBottomNav: true,
        //     enableSwitchMate: true,
        //     layout: {
        //       hideRightSidebar: true,
        //     },
        //   },
        //   children: [
        //     {
        //       path: "",
        //       name: "home",
        //       component: DungeonsHome,
        //     },
        //     {
        //       path: "search",
        //       name: "search",
        //       component: SearchPage,
        //     },
        //     {
        //       path: "nsfw-ai/chat/mate-tag",
        //       name: "nsfwChatMateTag",
        //       component: SearchPage,
        //       meta: {
        //         auth: false,
        //         layout: {
        //           hideRightSidebar: true,
        //         },
        //       },
        //     },
        //   ],
        // },
        {
          path: "mine",
          name: "mine",
          component: DungeonsMine,
          meta: {
            showBottomNav: true,
            enableSwitchMate: true,
            layout: {
              showHotCharacter: true,
            },
            auth: true,
          },
        },
        {
          path: "dungeon/create",
          name: "dungeonsCreate",
          component: DungeonsCreate,
        },
        {
          path: "dungeon/:uuid",
          name: "dungeonsDetail",
          component: DungeonsDetail,
        },
        {
          path: "dungeon",
          name: "dungeonsDetail1",
          component: DungeonsDetail,
        },
        {
          path: "framework",
          name: "framework",
          component: DungeonsRoom,
        },
        {
          path: "thread/create",
          name: "createThread",
          component: CreateThread,
          meta: { auth: true },
        },
        {
          path: "thread/:uuid",
          name: "threadDetail",
          component: ThreadDetail,
        },
        {
          path: "treehole/:uuid",
          name: "treeholeDetail",
          component: TreeholeThreadDetail,
        },
        {
          path: "planet/:uuid",
          name: "planetHome",
          component: PlanetDetail,
        },
        {
          path: "adoption",
          name: "adoptionHome",
          component: AdoptionHome,
          meta: {
            auth: false,
          },
        },
        {
          path: "adoption/create",
          name: "adoptionCreate",
          component: AdoptionCreate,
          meta: {
            auth: true,
          },
        },
        {
          path: "driftCapsule",
          name: "driftCapsuleHome",
          component: DriftCapsuleListPage,
          meta: {
            auth: true,
          },
        },
        // {
        //   path: "driftCapsule/list",
        //   name: "driftCapsuleList",
        //   component: DriftCapsuleListPage,
        //   meta: {
        //     auth: true,
        //   },
        // },
        {
          path: "mate/:uuid",
          name: "mateHome",
          component: MateHome,
          meta: {
            layout: {
              showHotCharacter: true,
            },
          },
        },
        {
          path: "mate/memory",
          name: "mateMemory",
          component: MateMemoryPage,
          meta: {
            auth: true,
          },
        },
        {
          path: "mate/memory/edit",
          name: "mateMemoryEdit",
          component: MateMemoryEdit,
          meta: {
            auth: true,
          },
        },
        {
          path: "user/:mateUuid",
          name: "userHome",
          component: MateHomeUser,
        },
        {
          path: "mate/mine",
          name: "myMate",
          component: MateHome,
          meta: {
            showBottomNav: true,
            auth: true,
            enableSwitchMate: true,
            layout: {
              showHotCharacter: true,
            },
          },
        },

        {
          path: "mission/dispatch/rank",
          name: "missionDispatchRank",
          component: MissionDispatchRank,
          meta: {
            auth: true,
          },
        },
        {
          path: "mate/edit/:uuid",
          redirect: (to) => ({
            name: "mateEdit",
            params: { uuid: to.params.uuid },
          }),
        },
        {
          path: "mate/tone",
          name: "mateTone",
          component: MateToneModule,
          meta: { auth: true, showBottomNav: false },
        },
        {
          path: "mate/timeline",
          name: "mateTimeline",
          component: MateTimelineView,
          meta: { auth: true, showBottomNav: false },
        },
        {
          path: "worldview/profile/edit/:uuid",
          name: "worldviewEdit",
          component: ModuleEdit,
          meta: { auth: true, showBottomNav: false },
        },
        {
          path: "worldview/planet-generator",
          name: "planetGenerator",
          component: PlanetGenerator,
        },
        {
          path: "/mate/profile/edit/:uuid",
          name: "profileSetting",
          meta: {
            auth: true,
            layout: { hideRightSidebar: true },
            showBottomNav: true,
          },
          component: ProfileSetting,
          children: [
            {
              path: "",
              name: "mateEdit",
              component: ModuleEdit,
              meta: { auth: true, showBottomNav: false },
            },
            {
              path: "scenario/edit",
              name: "scenarioEdit",
              component: ChatSceneEdit,
              meta: { auth: true, showBottomNav: false },
            },
            {
              path: "sprite",
              name: "spriteEdit",
              component: DungeonsSpriteEdit,
              meta: { auth: true, showBottomNav: false },
            },
          ],
        },
        {
          path: "mateWish/home",
          name: "mateWishHome",
          component: MateWishHome,
        },
        {
          path: "mateWish/edit",
          name: "mateWishEdit",
          component: MateWishEdit,
        },
        {
          path: "mateWish/demo",
          name: "mateWishDemo",
          component: MateWishDemo,
        },
        {
          path: "mateWish/detail/:uuid",
          name: "mateWishDetail",
          component: MateWishDetail,
        },
        {
          path: "notification/list",
          name: "notificationList",
          component: NotificationList,
          meta: { auth: true },
        },
        {
          path: "/chat",
          name: "chatView",
          component: ChatView,
          meta: {
            showBottomNav: true,
            auth: false,
            enableSwitchMate: true,
            layout: {
              hideRightSidebar: true,
              showHotCharacter: true,
            },
          },
          children: [
            {
              path: "",
              name: "chatList",
              component: ChatEmpty,
            },
            {
              path: "mate/list/:uuid",
              name: "mateChatList",
              component: MateChatListPage,
            },
            {
              path: "mate/:mateSessionId/:uuid",
              name: "mateChat",
              component: MateChatView,
              meta: { showBottomNav: false },
            },
          ],
        },
        {
          path: "social/list",
          name: "socialList",
          component: SocialList,
          meta: { auth: true },
        },
        {
          path: "friend/invitation",
          name: "friendInvitation",
          component: FriendInvitation,
          meta: { auth: true, showBottomNav: true },
        },
        {
          path: "friend/list",
          name: "friendList",
          component: FriendList,
          meta: { auth: true },
        },
        {
          path: "roleplay/home",
          name: "roleplayHome",
          component: RoleplayHome,
          meta: {
            showBottomNav: false,
            auth: false,
          },
        },
        {
          path: "roleplay/list/:uuid",
          name: "roleplayList",
          component: RoleplayList,
          meta: { auth: false },
        },
        {
          path: "roleplay/explore",
          name: "roleplayExplore",
          component: RoleplayExplore,
          meta: { auth: false },
        },
        {
          path: "roleplay/detail/:uuid",
          name: "roleplayDetail",
          component: RoleplayDetail,
          meta: { auth: true },
        },
        {
          path: "commit/:uuid",
          name: "threadCommit",
          component: ThreadCommit,
          meta: { auth: true },
        },
        {
          path: "moment/chain",
          name: "momentChain",
          component: MomentChain,
        },
        {
          path: "share/chat/:uuid",
          name: "shareChatPreview",
          component: ChatSharePreview,
        },
        {
          path: "login",
          name: "login",
          component: LoginOrRegister,
        },
        {
          path: "register",
          name: "register",
          component: UserRegister,
        },
        {
          path: "request/list",
          name: "requestList",
          component: RequestList,
          meta: { auth: true },
        },
        {
          path: "generation/image/list",
          name: "imageGenerateList",
          // component: ImageGenerateList,
          component: TaskList,
          meta: { auth: true, enableSwitchMate: true },
        },
        {
          path: "generation/image/create",
          name: "imageGeneration",
          component: CreateMutiTraitImage,
          meta: { auth: true, enableSwitchMate: true },
        },
        {
          path: "generation/image/imagePaintWithMode",
          name: "imagePaintWithMode",
          component: CreateImageWithMode,
          meta: { auth: true },
        },
        {
          path: "generation/image/paint",
          name: "imagePaintGeneration",
          component: CreateImagePaint,
          meta: { auth: true },
        },
        {
          path: "generation/video/create",
          name: "videoGeneration",
          component: CreateVideoTask,
          meta: { auth: true },
        },
        {
          path: "generation/storyScene/create",
          name: "storySceneGeneration",
          component: CreateStorySceneTask,
          meta: { auth: true },
        },
        {
          path: "generation/trait/create",
          name: "createTraitTask",
          component: CreateTraitTask,
          meta: { auth: true },
        },
        {
          path: "generation/trait/extraction",
          name: "traitFeatureExtraction",
          component: TraitFeatureExtraction,
          meta: { auth: true },
        },
        {
          path: "generation/trait/list",
          name: "traitFeatureList",
          component: GenerationTraitList,
          meta: { auth: true, enableSwitchMate: true },
        },
        {
          path: "generation/trait/portrait-list",
          name: "portTraitList",
          component: PortTraitList,
          meta: { auth: true },
        },
        {
          path: "generation/trait/portrait-edit",
          name: "portraitEdit",
          component: PortraitEdit,
          meta: { auth: true },
        },
        {
          path: "generation/trait/animation/list",
          name: "animationList",
          component: AnimationList,
          meta: { auth: true },
        },
        {
          path: "generation/trait/animation/create",
          name: "createAnimation",
          component: CreateAnimation,
          meta: { auth: true },
        },
        {
          path: "story/img-module",
          name: "storyImgModule",
          component: StoryImgModule,
          meta: { auth: true },
        },
        {
          path: "story/editor/:uuid",
          name: "storyEditor",
          component: StoryEditor,
          meta: { auth: true },
        },
        {
          path: "story/list",
          name: "storyList",
          component: StoryList,
          meta: { auth: true, enableSwitchMate: true },
        },
        {
          path: "story/edit",
          name: "storyEdit",
          component: StoryBookEdit,
          meta: { auth: true },
        },
        {
          path: "story/edit/role",
          name: "storyEditRole",
          component: StoryBookEditRole,
          meta: { auth: true },
        },
        {
          path: "story/edit/role/add",
          name: "storyEditRoleAdd",
          component: StoryBookEditRoleAdd,
          meta: { auth: true },
        },
        {
          path: "story/edit/moment", // storyBookUuid
          name: "storyEditMoment",
          component: StoryBookEditMoment,
          meta: { auth: true },
        },
        {
          path: "story/create/from-moment", // storyBookUuid
          name: "storyCreateFromMoment",
          component: StoryRelatingMoment,
          meta: { auth: true },
        },
        {
          path: "story/relating-moment",
          name: "storyRelatingMoment",
          component: StoryRelatingMoment,
          meta: { auth: true },
        },
        {
          path: "story/:uuid",
          name: "storyHome",
          component: StoryHome,
          meta: { auth: true },
        },
        {
          path: "story/info/:uuid",
          name: "storyInfo",
          component: StoryInfo,
          meta: { auth: true },
        },
        {
          path: "story/read/:uuid",
          name: "readStory",
          component: ReadStory,
          meta: { auth: false },
        },
        {
          path: "story/share/:uuid",
          name: "storyShare",
          component: StoryShare,
          meta: { auth: false, internal: true },
        },
        {
          path: "story-book/:uuid",
          name: "storyBookHome",
          component: StoryBookHome,
          meta: { auth: false },
        },
        {
          path: "story/reply/:uuid",
          name: "storyReply",
          component: StoryReply,
          meta: { auth: false },
        },
        {
          path: "story-book/reply/:uuid",
          name: "storyBookReply",
          component: StoryBookReply,
          meta: { auth: false },
        },
        {
          path: "chat/create/:uuid",
          name: "chatCreate",
          component: CreateChatGuide,
          meta: { auth: true },
        },
        {
          path: "inpainting",
          name: "inpainting",
          component: CreateInpainting,
          meta: { auth: true },
        },
        {
          path: "inpainting-editor",
          name: "inpaintingEditor",
          component: InpaintingEditor,
          meta: { auth: true },
        },
        {
          path: "game",
          name: "galGame",
          component: GalGameHome,
          meta: { auth: true, enableSwitchMate: true },
        },
        {
          path: "game/home",
          name: "galGameHome",
          redirect: "game",
          meta: { auth: true },
        },
        {
          path: "game/:uuid",
          name: "galGameDetail",
          component: GalGameDetail,
          meta: { auth: false },
        },
        {
          path: "game/:uuid/editor",
          name: "galGameEditor",
          component: GalGameEditor,
          meta: { auth: true },
        },
        {
          path: "game/:uuid/editor/dialog",
          name: "galGameEditorDialog",
          component: GalGameEditorDialog,
        },
        {
          path: "game/:uuid/editor/connect",
          name: "galGameEditorConnect",
          component: GalGameEditorConnect,
        },
        {
          path: "multiple-image-merge",
          name: "multipleImageMerge",
          component: MultipleImageMergeEditor,
          meta: { auth: true },
        },
        {
          path: "performance-editor",
          name: "performanceEditor",
          component: PerformanceEditor,
          meta: { auth: true },
        },
        {
          path: "story-performance-editor",
          name: "storyPerformanceEditor",
          component: StoryPerformanceEditor,
          meta: { auth: true },
        },
        {
          path: "coin/task",
          name: "coinTask",
          component: CoinTask,
          meta: { auth: true },
        },
        {
          path: "coin/records",
          name: "coinBalanceRecord",
          component: CoinBalanceRecord,
          meta: { auth: true },
        },
        {
          path: "transaction",
          name: "transaction",
          component: TransactionPage,
          meta: { auth: true },
        },
        {
          path: "transaction/records",
          name: "transactionRecords",
          component: TransactionRecord,
          meta: { auth: true },
        },
        {
          path: "rank/vote",
          name: "rankVoteList",
          component: RankVoteList,
        },
        {
          path: "rank/list",
          name: "rankList",
          component: RankList,
        },
        {
          path: "rank",
          name: "rankDetail",
          component: RankSeasonDetail,
        },
        {
          path: "rank/reply",
          name: "rankReplyList",
          component: RankReplyList,
        },
        {
          path: "rank/rules-explanation",
          name: "rankRulesExplanation",
          component: RankRules,
        },
        {
          path: "paypal",
          name: "paypal",
          component: PaypalPage,
          meta: { auth: true },
        },
        {
          path: "withdrawal",
          name: "withdrawal",
          component: WithdrawalPage,
          meta: { auth: true },
        },
        {
          path: "withdrawal/records",
          name: "withdrawalRecords",
          component: WithdrawalRecordPage,
          meta: { auth: true },
        },
        {
          path: "collection/:uuid",
          name: "collectionMain",
          component: MainCollection,
          meta: { auth: false },
        },
        {
          path: "collection/edit",
          name: "collectionEdit",
          component: EditCollection,
          meta: { auth: true },
        },
        {
          path: "collection/list",
          name: "collectionList",
          component: ListCollection,
          meta: { auth: true, enableSwitchMate: true },
        },
        {
          path: "mail/list",
          name: "mailList",
          component: MateMailListPage,
          meta: { auth: true },
        },
        {
          path: "mail/edit",
          name: "mailEdit",
          component: MateMailEdit,
          meta: { auth: true },
        },
        {
          path: "mail/detail/:uuid",
          name: "mailDetail",
          component: MateMailDetail,
          meta: { auth: true },
        },
        {
          path: "thread/list",
          name: "threadList",
          component: ThreadList,
          meta: { auth: true, enableSwitchMate: true },
        },
        {
          path: "goldTicket/balance",
          name: "goldTicketBalance",
          component: GoldTicketBalance,
          meta: { auth: true },
        },
        {
          path: "goldTicket/balance/record",
          name: "goldTicketBalanceRecord",
          component: GoldTicketBalanceRecord,
          meta: { auth: true },
        },
        {
          path: "application/senior-reader",
          name: "seniorReaderApplication",
          component: SeniorReaderApplication,
          meta: { auth: true },
        },
        {
          path: "/crystal",
          name: "Crystal",
          component: Crystal,
          meta: { auth: true },
        },
        {
          path: "/member",
          name: "member",
          component: MemberPage,
        },
        {
          path: "/member/center",
          name: "memberCenter",
          component: MemberCenterPage,
          meta: { auth: true },
        },
        {
          path: "/manager/prompt",
          name: "ManagerPrompt",
          component: ManagerPrompt,
          meta: {
            auth: true,
            layout: {
              hideRightSidebar: true,
            },
          },
        },
        {
          path: "/contact-us",
          name: "contactUs",
          component: ContactUs,
        },
        {
          path: "/text-image-explore",
          name: "textImageExploreItem",
          component: TextImageExploreItem,
          meta: {
            auth: false,
            layout: {
              hideRightSidebar: true,
            },
          },
        },
        {
          path: "/nsfw-ai/chat/:name/:uuid",
          alias: "/mate/chat/:name/:uuid",
          name: "mateChatIntro",
          component: MateChatIntro,
          meta: {
            enableSwitchMate: true,
            auth: false,
            layout: {
              hideRightSidebar: true,
            },
          },
        },
        {
          path: "/redeem/:code",
          redirect: (to) => ({
            name: "home",
            query: { redeemCode: to.params.code },
            replace: true,
          }),
        },
        {
          path: "/setting",
          component: AccountSettings,
          meta: {
            auth: false,
            enableSwitchMate: true,
            layout: {
              hideRightSidebar: true,
            },
          },
          children: [
            {
              path: "",
              name: "setting",
              component: AccountSettingsEmpty,
            },
            {
              path: "/setting/account",
              name: "accountInfo",
              component: AccountInfo,
            },
            {
              path: "/setting/content",
              name: "contentSetting",
              component: ContentSetting,
            },
            {
              path: "/setting/appearance",
              name: "appearanceSetting",
              component: AppearanceSetting,
            },
            {
              path: "/setting/language",
              name: "languageSetting",
              component: LanguageSetting,
            },
            {
              path: "/setting/preference",
              name: "preferenceSetting",
              component: PreferenceSetting,
            },
            {
              path: "/about",
              name: "about",
              component: About,
            },
          ],
        },
        {
          path: "/user/task",
          name: "userTask",
          component: UserTask,
          meta: {
            showBottomNav: false,
            title: "我的任务",
          },
        },
        {
          path: "/policy",
          name: "policy",
          component: PolicyPage,
        },
        {
          path: "/game-demo-list",
          name: "gameDemoList",
          component: GameDemoList,
          meta: {
            auth: true,
          },
        },
        {
          path: "/sprite",
          name: "sprite",
          component: SpriteModule,
          meta: {
            auth: true,
          },
        },
        {
          path: "/gallery",
          name: "gallery",
          component: GalleryView,
          meta: {
            auth: true,
          },
        },
        {
          path: "/draw",
          name: "draw",
          component: DrawCanvas,
          meta: {
            auth: true,
          },
        },
        {
          path: "/share/xhs",
          name: "shareXhs",
          component: ShareXhs,
        },
        {
          path: "/beautify",
          name: "beautify",
          component: BeautifyView,
          meta: {
            auth: false,
          },
        },
        {
          path: "/house",
          component: PhaserGame,
          name: "dreamHome",
          meta: {
            auth: true,
            showBottomNav: true,
          },
          children: [
            {
              path: "interaction/review",
              name: "interactionReview",
              component: InteractionReviewList,
              meta: {
                openPopup: true,
              },
            },
            {
              path: "interaction/list",
              name: "interactionList",
              component: InteractionEventListView,
              meta: {
                openPopup: true,
              },
            },
            {
              path: "mail/list",
              name: "mailList",
              component: MateMailListPage,
              meta: {
                openPopup: true,
              },
            },
            {
              path: "mail/edit",
              name: "mailEdit",
              component: MateMailEdit,
              meta: {
                openPopup: true,
              },
            },
            {
              path: "mail/detail/:uuid",
              name: "mailDetail",
              component: MateMailDetail,
              meta: {
                openPopup: true,
              },
            },

            {
              path: "interactive/relationship",
              name: "relationshipList",
              component: HomeInteractiveRelation,
              meta: {
                openPopup: true,
              },
            },
            {
              path: "interactive/relationship/other",
              name: "relationshipOther",
              component: HomeInteractiveRelationOther,
              meta: {
                openPopup: true,
              },
            },
            {
              path: "interactive/relationship/my",
              name: "relationshipMy",
              component: HomeInteractiveRelationMy,
              meta: {
                openPopup: true,
              },
            },
            {
              path: "furnish/list",
              name: "furnishList",
              component: FurnishList,
              meta: {
                openPopup: true,
              },
            },
            {
              path: "world-mission/list",
              name: "worldMissionList",
              component: WorldMissionList,
              meta: {
                openPopup: true,
              },
            },
          ],
        },
        {
          path: "mission/home",
          name: "missionHome",
          component: MissionHome,
          meta: {
            openPopup: true,
          },
        },
        {
          path: "mission/edit",
          name: "missionEdit",
          component: MissionEdit,
          meta: {
            openPopup: true,
          },
        },
        {
          path: "mission/detail",
          name: "missionDetail",
          component: MissionEdit,
          meta: {
            openPopup: true,
          },
        },
        {
          path: "mission/journey",
          name: "missionJourney",
          component: MissionJourney,
          meta: {
            openPopup: true,
          },
        },
        {
          path: "mission/journey/item",
          name: "missionJourneyItem",
          component: MissionJourneyItem,
          meta: {
            openPopup: true,
          },
        },
        {
          path: "world-mission/edit",
          name: "worldMissionEdit",
          component: WorldMissionEdit,
          meta: {
            openPopup: true,
          },
        },
        {
          path: "mission/equipment",
          name: "missionEquipment",
          component: MissionEquipment,
          meta: {
            openPopup: true,
          },
        },
        {
          path: "mission/dialogue/:dispatchUuid",
          name: "missionDialgue",
          component: MissionDialogue,
          meta: {
            openPopup: true,
          },
        },
        // {
        //   path: "/mate/treehole",
        //   name: "treeholeIndex",
        //   component: TreeholeIndex,
        //   meta: {
        //     auth: true,
        //     showBottomNav: true,
        //   },
        // },
        {
          path: "/mate/treehole/create",
          name: "treeholeCreate",
          component: TreeholeCreate,
        },
        {
          path: "/mate/treehole/connect",
          name: "treeholeConnect",
          component: TreeholeConnect,
        },
        {
          path: "/mate/treehole/self-setting",
          name: "treeholeSelfSetting",
          component: TreeholeSelfEdit,
        },
        {
          path: "/playground",
          name: "playgroundHome",
          component: PlaygroundHome,
          meta: {
            auth: true,
            showBottomNav: true,
          },
        },
      ],
    },
    {
      path: "/zh",
      alias: ["/en"],
      redirect: "/",
    },
    {
      path: "/zh/thread/:uuid",
      alias: ["/en/thread/:uuid"],
      redirect: (to) => ({
        name: "threadDetail",
        params: { uuid: to.params.uuid },
      }),
    },
    {
      path: "/zh/story/read/:uuid",
      alias: ["/en/story/read/:uuid"],
      redirect: (to) => ({
        name: "readStory",
        params: { uuid: to.params.uuid },
      }),
    },
    // {
    //   path: "/v1",
    //   name: "v1",
    //   component: () => import("@/views/HomeView.vue"),
    //   children: [
    //     {
    //       path: "/",
    //       name: "default",
    //       redirect: "community",
    //     },
    //     {
    //       path: "mate",
    //       name: "mateList",
    //       component: () => import("@/components/mateList.vue"),
    //     },
    //     {
    //       path: "community",
    //       name: "communityList",
    //       component: () => import("@/components/communityPage.vue"),
    //     },
    //
    //     {
    //       path: "setting",
    //       name: "settingDetail",
    //       component: () => import("@/components/settingDetail.vue"),
    //     },
    //     {
    //       path: "sp/:uuid",
    //       name: "savePoint",
    //       component: () => import("@/components/detailPage.vue"),
    //     },
    //     {
    //       path: "mate/:uuid",
    //       name: "updateMate",
    //       component: () => import("@/components/updateMate/updateMate.vue"),
    //     },
    //     {
    //       path: "graph/:uuid",
    //       name: "graph",
    //       component: () => import("@/components/graph/MateGraph.vue"),
    //     },
    //     {
    //       path: "notifications",
    //       name: "notificationList",
    //       component: () => import("@/components/notificationList.vue"),
    //     },
    //     {
    //       path: "user/:id",
    //       name: "userDetail",
    //       component: () => import("@/components/userDetail.vue"),
    //     },
    //   ],
    // },
    {
      path: "/testC",
      name: "test",
      component: PageTest,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

router.beforeEach((to, from) => {
  const globalUser = useGlobalUser();
  if (to.meta && to.meta.auth && !globalUser.isLogin) {
    // 此路由需要授权，请检查是否已登录
    // 如果没有，则重定向到登录页面
    if (!from.name) {
      return {
        name: "discover",
        // 保存我们所在的位置，以便以后再来
        query: { redirect: to.fullPath },
      };
    }
    globalUser.loginModal.show = true;
    // return {
    //   name: "mateCreate",
    // };
    return false;
  }
});
router.afterEach((to) => {
  // 落地页标记：进入APP后的首个页面
  if (!history.state.back) {
    to.meta.landingPage = true;
  }
});

export default router;
